import { Fragment, type ReactNode } from "react";

const SLOT_REGEX = /\{(\w+)\}/;

/**
 * Fill `{name}` slots of a translated sentence with styled nodes.
 *
 * A sentence with emphasised or monospaced words used to be rendered from several string
 * fragments around JSX elements, which fixes the word order. Keeping the sentence as one
 * string lets a language move the emphasised words wherever its grammar wants them. An
 * unknown slot is left as visible `{name}` text, like `t()` does.
 */
export function fillSlots(
  template: string,
  slots: Record<string, ReactNode>
): ReactNode[] {
  const nodes: ReactNode[] = [];
  let offset = 0;
  for (const [index, part] of template.split(SLOT_REGEX).entries()) {
    const isSlot = index % 2 === 1;
    nodes.push(
      isSlot ? (
        <Fragment key={`slot-${offset}-${part}`}>
          {slots[part] ?? `{${part}}`}
        </Fragment>
      ) : (
        part
      )
    );
    offset += part.length;
  }
  return nodes;
}
